import AuctionDetails from "../components/AuctionListing/AuctionDetails";
import Details from "../components/AuctionListing/Details";
import Icon from "../components/AuctionListing/Icon";
import Image from "../components/AuctionListing/Image";
import MapLocation from "../components/AuctionListing/MapLocation";
import Container from "../components/layout/Container";
import OtherSellerDescription from "../components/OthersCustomFiledForm/OtherAuctionSellerDescription";
import MoreItems from "../components/Shared/MoreItems/MoreItems";
import { products } from "../data/products";

const OtherAuctionCustomDisplay = () => {
  return (
    <Container>
      <Icon />
      <div className="flex items-start justify-between">
        <div>
          <Image />
          <Details />
        </div>
        <div>
          <AuctionDetails />
          <OtherSellerDescription />
          <MapLocation />
        </div>
      </div>
      <MoreItems products={products} title="MORE ITEMS FROM THIS SELLER" />
      <MoreItems products={products} title="SIMILAR ITEMS" />
    </Container>
  );
};

export default OtherAuctionCustomDisplay;
